import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=474ce251&"
import script from "./Templates.vue?vue&type=script&lang=ts&"
export * from "./Templates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports